// CourseDetail.jsx
import { useRef } from "react";
import React, { useState } from "react";
import {
  Box,
  Grid,
  Card,
  CardHeader,
  CardContent,
  Typography,
  Button,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  TextField,
} from "@mui/material";
import { APP_BAR_HEIGHT } from "../constants/layout";
// import { useParams } from "react-router-dom";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import TopAppBar from "./TopAppBar";

export default function CourseDetail() {
  const fileInputRef = useRef(null);
  const CLOUD_RUN_UPLOAD_URL =
    "https://upload-file-188976723880.europe-west1.run.app";
  

  const handleSyllabusClick = () => {
    fileInputRef.current.click();
  };

  const handleSyllabusUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    if (file.type !== "application/pdf") {
      alert("Please upload a PDF file");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("courseId", "CS101"); // optional metadata

    try {
      const id_token = sessionStorage.getItem('id_token')
      console.log(id_token)
      const response = await fetch(CLOUD_RUN_UPLOAD_URL, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${id_token}`, // Google ID token or your JWT
        },
        body: formData,
      });
      
      if (!response.ok) {
        throw new Error("Upload failed");
      }

      alert("Syllabus uploaded successfully");
    } catch (err) {
      console.error(err);
      alert("Error uploading syllabus");
    }
  };



  const [editing, setEditing] = useState(false);
  const [instructions, setInstructions] = useState(
    "Welcome to the Computer Science course. Please find lecture and assignment materials posted here. Good luck!"
  );

  const files = [
    "Lecture_1.pdf",
    "Lecture_2.pdf",
    "Assignment_2.docx",
    "Notes_Ch3.pdf",
  ];

  return (
    <>
      <TopAppBar />

      <Box sx={{ px: { xs: 2, md: 4 }, py: 4, backgroundColor: "#f6f8fc", minHeight: "100vh",mt: `${APP_BAR_HEIGHT}px` }}>
        {/* Header */}
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 4 }}>
          <Typography variant="h5" fontWeight={600}>
            Course Resources
          </Typography>

          <Button
            variant="contained"
            startIcon={<ContentCopyOutlinedIcon />}
            sx={{ borderRadius: 2 }}
          >
            Copy Link
          </Button>
        </Box>

        <Grid container spacing={3} alignItems="stretch">
          {/* Course Files */}
          <Grid item xs={12} md={4}>
            <Card sx={{ height: "100%", borderRadius: 3 }}>
              <CardHeader title="Course Files" />
              <CardContent>
                <List dense>
                  {files.map((file, idx) => (
                    <ListItem
                      key={idx}
                      secondaryAction={
                        <IconButton edge="end">
                          <DeleteOutlineIcon color="error" />
                        </IconButton>
                      }
                    >
                      <ListItemIcon>
                        <InsertDriveFileOutlinedIcon />
                      </ListItemIcon>
                      <ListItemText primary={file} />
                    </ListItem>
                  ))}
                </List>

                <Divider sx={{ my: 2 }} />

                <Button
                  fullWidth
                  variant="outlined"
                  startIcon={<UploadFileIcon />}
                >
                  Upload New File
                </Button>
              </CardContent>
            </Card>
          </Grid>
          <input
        ref={fileInputRef}
        type="file"
        accept="application/pdf"
        hidden
        onChange={handleSyllabusUpload}
      />
          {/* Syllabus Upload */}
          <Grid item xs={12} md={4}>
            <Card
              sx={{
                height: "100%",
                borderRadius: 3,
                border: "2px dashed #cfd8dc",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
              }}
            >
              <CardContent>
                <CloudUploadOutlinedIcon sx={{ fontSize: 48, color: "primary.main", mb: 1 }} />
                <Typography fontWeight={600}>Syllabus</Typography>
                <Typography variant="body2" color="text.secondary" mb={2}>
                  Drag & drop syllabus PDF here
                </Typography>
                <Button variant="contained" onClick={handleSyllabusClick}>Upload Syllabus</Button>
              </CardContent>
            </Card>
          </Grid>

          {/* Instructions */}
          <Grid item xs={12} md={4}>
            <Card sx={{ height: "100%", borderRadius: 3 }}>
              <CardHeader title="Course Instructions" />
              <CardContent sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                <TextField
                  multiline
                  minRows={6}
                  value={instructions}
                  onChange={(e) => setInstructions(e.target.value)}
                  disabled={!editing}
                  fullWidth
                />

                {!editing ? (
                  <Button
                    variant="outlined"
                    startIcon={<EditOutlinedIcon />}
                    onClick={() => setEditing(true)}
                  >
                    Edit Instructions
                  </Button>
                ) : (
                  <Button
                    variant="contained"
                    startIcon={<SaveOutlinedIcon />}
                    onClick={() => setEditing(false)}
                  >
                    Save Instructions
                  </Button>
                )}
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
